module.exports = __webpack_public_path__ + "static/media/06.e74b72e5.jpg";